/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import { Common } from '@stockbit/ui';
import Image from 'global/Image';
import { useState } from 'react';
import { ImageItemWrapper, ImgModal } from '../styled';

const { Modal } = Common;

interface ImageContainerProps {
  src: string;
  imageStyle?: any;
  [key: string]: any;
}

function ImageContainer({ src, imageStyle, ...props }: ImageContainerProps) {
  const [visible, setVisible] = useState(false);

  return (
    <>
      <ImageItemWrapper {...props}>
        <Image
          src={src}
          alt="convo pict"
          onClick={() => setVisible(true)}
          style={imageStyle || {}}
        />
      </ImageItemWrapper>
      <Modal
        visible={visible}
        centered
        maskClosable
        footer={null}
        width="auto"
        bodyStyle={{ padding: '0px' }}
        onCancel={() => setVisible(false)}
      >
        <ImgModal alt="" src={src} />
      </Modal>
    </>
  );
}

export default ImageContainer;
